export default "__VITE_ASSET__D1$vhP9u__"